import { Instagram, Youtube } from "lucide-react";
import { SOCIALS } from "@/lib/api";
import { DiscordIcon, TikTokIcon } from "@/components/icons";

const ICONS = { Instagram: Instagram, YouTube: Youtube, TikTok: TikTokIcon, Discord: DiscordIcon };

export const SocialMarquee = () => {
  const items = [...SOCIALS, ...SOCIALS, ...SOCIALS];
  return (
    <div data-testid="social-marquee" className="border-y border-[#2A2A2A] bg-[#0A0A0A] py-4 overflow-hidden">
      <div className="marquee-track flex w-max items-center gap-12">
        {[...items, ...items].map((s, i) => {
          const Icon = ICONS[s.name];
          return (
            <a
              key={i}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 font-bebas text-xl tracking-[0.3em] text-[#39FF14]/80 hover:text-[#39FF14] transition-colors whitespace-nowrap"
            >
              <Icon size={18} />
              {s.name.toUpperCase()}
              <span className="text-[#D90429] mx-4">✕</span>
            </a>
          );
        })}
      </div>
    </div>
  );
};
